/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScoreboardBreakdown = {
    properties: {
        events: {
    type: 'array',
    contains: {
        type: 'EventMetric',
    },
    isRequired: true,
},
        employeeScores: {
    type: 'array',
    contains: {
        type: 'ScoreboardBreakdownEmployeeScores',
    },
    isRequired: true,
},
        beginAt: {
    type: 'string',
    isRequired: true,
},
        endAt: {
    type: 'string',
    isRequired: true,
},
    },
};